/* tslint:disable:max-line-length */
export default {
	/* Registration */
	buy_property: {
		en: "Enter your booking reference number that you have received from seller and proceed to next step.",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل البيع والشراء (الكلي \\ الجزئي ) عن طريق شراء أرض أو عقار أو وحدة عقارية (مكتملة أو قيد الإنشاء)",
	},
	project_status: {
		en: "Provides real-time information of projects progress, projects details, projects inspection reports, developer details and ESCROW account details.",
		ar: "عرض معلومات آنية عن نسب انجاز المشاريع، تفاصيل المشاريع، تقارير التفتيش على المشاريع وتفاصيل حساب الضمان.",
	},
	ownership_certificate: {
		en: "Verify a title deed by entering owner name, certificate number, certificate year and property type.",
		ar: " تتيح هذه الخدمة للمتعاملين القيام بالتحقق من شهادة التملك للعقار خلال ادخال البيانات الموجودة في ملكية العقار مثل اسم المالك، رقم الشهادة، سنة استخراج الشهادة، المساحة بالمتر المربع، ونوع العقار.",
	},
	twimc: {
		en: "Request for new whomsoever it may concern certificate. Go to My Request to view past requests. ",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان أملاك المتعامل أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
	},
	myrequest: {
		en: "View your past requests, check the status and option for new request.",
		ar: "عرض طلباتك السابقة ، و تحقق من الحالة و الخيار للطلب الجديد",
	},
	svc_catalogue: {
		en: "Download documents on DLD services. Documents will provide details of process, required documents and fees.",
		ar: "قم بتنزيل المستندات على خدمات دائرة الأراضي و الأملاك. الوثائق سوف توفر تفاصيل عن العملية و المستندات المطلوبة و الرسوم",
	},
	procedure_status_enquiry: {
		en: "Get the status of a transaction and its status  by entering the number and type of the transaction.",
		ar: "هي خدمة  تتيح للمتعاملين الاستعلام على حاله الإجراء إذا كان قد تم انجازه او قيد الانجاز أو متوقف لسبب ما بعد ادخال رقم الإجراء ونوع الاجراء. ",
	},
	transactions: {
		en: "Enter the date range and get the Sales or Mortgage transaction details by area. Option to view selected area transactions in a graph.",
		ar: "عرض تقارير عن معاملات البيع و الرهن العقاري.",
	},
	procedure_fee_calculator: {
		en: "Calculate the procedure fee by selecting the services provider and filling the required information.",
		ar: "احسب رسوم الإجراء عن طريق اختيار مزود الخدمة وملء المعلومات المطلوبة.",
	},
	owner_regi: {
		en: "Register with DLD using Emirates Id and submit for auditor approval. If you are already an owner, please proceed to login. ",
		ar: "قم بالتسجيل باستخدام رقم الهويه الإماراته ومن ثم قم بتقديم الطلب للموافقة من قبل المدقق. إذا كنت من ملاك العقارات، فيرجى المتابعة لتسجيل الدخول مباشرة.",
	},
	listings: {
		en: "View all listed properties for sell and lease",
		ar: "عرض جميع العقارات المدرجة للبيع والإيجار",
	},
	my_listings: {
		en: "Track your listed properties. De-list or update details. ",
		ar: "تتبع عقاراتك المدرجة للبيع أو للإيجار. حذف العقارات من القائمة أو تحديث التفاصيل.",
	},
	verify_valuation_certificate: {
		en: "Enter the valuation certificate details issued by third party VALUERS and verify from DLD.",
		ar: "أدخل تفاصيل شهادة التقييم الصادرة عن المقيميين و تحقق من دائرة الأراضي و الأملاك",
	},
	land_status: {
		en: "View property details by Makani, Land Number, and Municipality number. Search land using Map. ",
		ar: "عرض تفاصيل العقار حسب رقم مكاني ورقم الأرض ورقم البلدية. البحث عن الأرض باستخدام الخريطة.",
	},
	/*RERA*/
	legislation: {
		en: "This service allows customers to browse and review all real estate legislation in the Emirate of Dubai. ",
		ar: "تتيح هذه الخدمة للمتعاملين القيام باستعراض جميع القوانين العقارية المعمول بها في إمارة دبي",
	},
	rental_index: {
		en: "This service helps users to calculate the rent increase and average market rent by entering the information of the required area.",
		ar: "هي حاسبة يقوم المستخدم بإدخال البيانات للمنطقة المطلوبة ليتمكن بكل سهولة من الحصول على نسبة الزيادة ومتوسط بدل الإيجار فيها.",
	},
	dubai_brokers: {
		en: "View, search Brokers and broker offices by specialization, ranking, area, nationality and so on. View their transactions by year.",
		ar: "تتيح هذه الخدمة للمتعاملين البحث في قائمة الوسطاء العقاريين المرخصين من قبل مؤسسة التنظيم العقاري في دبي.",
	},
	e_card: {
		en: "Verify cards issued by RERA by activity type. Download the card for reference. ",
		ar: "تحقق من البطاقات الصادرة عن ريرا حسب نوع النشاط. قم بتحميل البطاقة للرجوع إليها",
	},
	search_trade_license: {
		en: "Search trade license numbers registered with DLD and check the validity. ",
		ar: "ابحث عن أرقام الرخص التجارية من  مع دائرة الأراضي و تحقق من الصلاحية ",
	},
	service_providers: {
		en: "View RT, PT, Management Companies, Valuation Company, Consultants and Owner's Association offices. ",
		ar: "عرض أمين التسجيل، الأمين العقاري،  شركات الإدارة، شركة التقييم، الاستشاريين، و مكاتب رابطة الملاك.",
	},
	service_charge_index: {
		en: "This service allows clients to inquire about the approved service fees for co-owned projects.",
		ar: "تتيح هذه الخدمة للمتعاملين الاستفسار عن رسوم الخدمة المعتمدة للمشاريع المشتركة.",
	},
	find_contract_usc: {
		en: "Enter the contract number that you have received from Broker to view details and take actions.",
		ar: "أدخل رقم العقد الذي تلقيته من الوسيط لعرض التفاصيل واتخاذ القرار.",
	},
	mollak_service_charges: {
		en: "View your Mollak Service Charge invoices, view payment history,  pay online and get receipts for your payment.",
		ar: "عرض فواتير رسوم الخدمات الخاصة بك على نظام ملاك، عرض تاريخ الدفع ،الدفع عبر الإنترنت واحصل على إيصالات دفعتك.",
	},
	register_certificate: {
		en: "This service allows tenant to register a new tenancy contract.",
		ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب لتسجيل عقد إيجار جديد.",
	},
	print_certificate: {
		en: "Download Ejari certificate",
		ar: "تحميل شهادة ايجاري",
	},
	who_is_managing: {
		en: "Search property and find management company details. ",
		ar: "البحث عن العقار  والوصول الى  تفاصيل شركة الإدارة القائمة على إدارة العقار.",
	},
	/* RDC */
	regi_case: {
		en: "This service allows customers to apply for registration of rental cases and reconciliation cases.",
		ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب لتسجيل القضايا الإيجارية و قضايا الصلح.",
	},
	view_case: {
		en: "This service allows customers to view rental case details.",
		ar: "تتيح هذه الخدمة للمتعاملين الاطلاع على تفاصيل القضايا الإيجارية.",
	},
	rdc_cert: {
		en: "Verify whether tenants and owners have any RDC cases. Download the good conduct certificate for reference.",
		ar: "تحقق ما إذا كان الملاك أو المستأجرين لديهم أي دعاوي في مركز فض المنازعات الإيجارية. قم بتحميل صحيفة الحالة الإيجارية للرجوع إليها.",
	},
	smart_judge: {
		en: "Smart Judge a contemporary application that enables rental parties to ascertain their legal position regarding disputes.",
		ar: "لقاضي الذكي وهو عبار تطبيق معاصر يمكن أطراف العلاقات الإيجارية من معرفة موقفهم القانوني في شأن النزاعات الإيجارية.",
	},
	track_case: {
		en: "This service allows customers to track the rental case.",
		ar: "تتيح هذه الخدمة للمتعاملين متابعة حالة القضايا الإيجارية.",
	},
	ques_ans: {
		en: "Most frequently asked questions related to rental disputes",
		ar: "الأسئلة الأكثر شيوعا المتعلقة بالمنازعات الإيجارية",
	},
	rdc_services: {
		en: "Download a copy of various RDC service details like process, required documents and fee structure.",
		ar: "قم بتحميل نسخة من تفاصيل خدمات المركز المختلفة مثل سير الإجراء والمستندات المطلوبة وهيكلية الرسوم.",
	},
	queue_request: {
		en: "Get your queuing tickets to visit RDC center at Dubai Land Department office. ",
		ar: "احصل على تذكرة قائمة الانتظار لزيارة مركز فض المنازعات الإيجارية في مكتب دائرة الأراضي و الأملاك بدبي",
	},
	/* My Requests*/
	loss_cert: {
		en: "This service allows owners of a land or other properties to apply for a replacement for a damaged/ lost Title Deed.",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار ملكية بدل تالف أو فاقد عن طريق طلب من مالك الأرض أو العقار.",
	},
	site_plan: {
		en: "This service allows customers to request issuing a property map according to the types of maps approved by the Planning Section at Dubai Land Department.",
		ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب لإصدار خارطة لعقار حسب أنواع الخرائط المعتمدة في خدمات إدارة المساحة في الدائرة.",
	},
	prop_valuation: {
		en: "This service allows customers to request real estate valuation.",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب تقييم بأنواعه.",
	},
	iprop_valuation: {
		en: "Submitted properties valuation requests for granting purposes.",
		ar: "الطلبات المرسلة لتقييم العقارات بغرض الهبة",
	},
	mortgage_quotation: {
		en: "Send your Mortgage request to Bank and receive quotations from Bank. ",
		ar: "أرسل طلب الرهن إلى البنك و استلم عروض الأسعار من البنك.",
	},
	electronic_title_deed: {
		en: "This Service enables clients to request the issuance of an electronic Title Deed.",
		ar: "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار سند ملكية الكترونى.",
	},
	my_sell_requests: {
		en: "View your private sale requests sent to buyers.",
		ar: "عرض طلبات البيع الخاص و إرسالها إلى المشتريين",
	},
	third_party_valuation: {
		en: "View your external valuation requests sent to valuation companies.",
		ar: "عرض طلبات التقييم الخارجية المرسلة إلى شركات التقييم",
	},
	register_certificate_request: {
		en: "View Ejari registration requests sent or received from tenant. ",
		ar: "عرض طلبات تسجيل إيجاري المرسلة أو المستلمة من إيجاري",
	},
	rvs_complaints: {
		en: "View your Real Estate Violation complaints status.",
		ar: "عرض حالة الشكاوى العقارية الخاصة بى",
	},
	/*DREI*/
	drei: {
		en: "Details of all DREI courses, share with others and option to register through DLD website.",
		ar: "تفاصيل جميع دورات معهد دبي العقاري و مشاركتها مع الآخرين و خيار التسجيل من خلال موقع دائرة الأراضي و الأملاك",
	},
	/*REIP*/
	sim: {
		en: "Smart market place for real estate projects for developers and investors.",
		ar: "سوق ذكي للمشاريع العقارية يخدم المطورين العقاريين والمستثمرين معا.",
	},
	/*Service Directory Sub services*/
	valuation_companies: {
		en: "Valuation companies registered with RERA with valid license. ",
		ar: "شركات التقييم المسجلة لدى ريرا مع ترخيص ساري المفعول",
	},
	management_companies: {
		en: "Management companies registered with RERA with valid license. ",
		ar: "شركات التسجيل المسجلة لدى ريرا مع ترخيص ساري المفعول",
	},
	property_trustees: {
		en: "Property Trustee office details",
		ar: "تفاصيل مكتب الأمين العقاري",
	},
	rt_offices_map: {
		en: "Registration Trustee office details.",
		ar: "تفاصيل مكتب أمين التسجيل",
	},
	approved_dev: {
		en: "Approved developers registered with RERA with valid license.",
		ar: "المطورين المعتمدين المسجلين لدرى ريرا مع ترخيص ساري المفعول",
	},
	mortgage_consultancy: {
		en: "Mortgage consultants registered with RERA with valid license.",
		ar: "استشاري الرهن العقاري المسجلين لدى ريرا مع ترخيص ساري المفعول",
	},
	real_state_consultancy: {
		en: "Real Estate Consultants registered with RERA with valid license.",
		ar: "المستشارين العقاريين المسجلين لدى ريرا مع ترخيص ساري المفعول",
	},
	owners_association: {
		en: "Owners associations registered with RERA with valid license.",
		ar: "جمعيات الملاك المسجلة لدى ريرا مع ترخيص ساري المفعول",
	},
	auditors: {
		en: "Approved Auditing firms registered with RERA with a valid license.",
		ar: "شركات التدقيق المعتمدة المسجلة لدى ريرا  بترخيص ساري المفعول.",
	},
	broker_offices: {
		en: "Approved Broker Offices registered with RERA with a valid license.",
		ar: "مكاتب الوساطة المعتمدة المسجلة لدى ريرا  بترخيص ساري المفعول.",
	},
	escrow_accounts: {
		en: "List of banks allows you to open and manage your Escrow Account",
		ar: "قائمة البنوك التي تسمح لك بفتح وإدارة حساب الضمان الخاص بك",
	},
	survey_companies: {
		en: "Approved Survey Companies registered with RERA with a valid license.",
		ar: "شركات المسح المعتمدة المسجلة لدى ريرا  بترخيص ساري المفعول.",
	},
	/*Awards*/
	awards: {
		en: "RERA Awards for real estate companies and professionals.",
		ar: "جوائز وكالة التنظيم العقاري  للشركات العقارية والمهنيين",
	},
	green_list: {
		en: "Using this service system will share your mobile number and email with brokers so that they can contact you for the sale/lease of your properties.",
		ar: "باستخدام هذه الخدمة سيعمل التطبيق على مشاركة رقم هاتفك الجوال وبريدك الإلكتروني مع الوسطاء حتى يتمكنوا من الاتصال بك لبيع/تأجير عقاراتك.",
	},
	rt_office_transaction_requests: {
		en: "Track your online procedure requests submitted to Registration Trustee offices.",
		ar: "تتبع طلبك فى مكتب أمين التسجيل.",
	},
	tasken: {
		en: "This service allows an investor to apply for a visa where the value of their residential unit equals or exceeds five million Dirhams.",
		ar: "تتيح هذه الخدمة لمستثمر العقار التقدم بطلب الحصول على إقامة للوحدات السكنية التي تساوي أو تزيد قيمتها الشرائية على خمس ملايين درهم.",
	},
	rental_valuation: {
		en: "This service allows customers to request for property rent valuation.",
		ar: "تتيح هذه الخدمة للمتعاملين تقديم طلب تقييم قيمة الإيجار للعقار.",
	},
	verify_green_list: {
		en: "By using this service, the system will verify a green list member.",
		ar: "باستخدام هذه الخدمة ، سيتحقق النظام من عضو القائمة الخضراء.",
	},
	raise_a_complaint_public: {
		en: "This service allow registration of complaints related to violations of real estate companies.",
		ar: "تتيح هذه الخدمة تقديم الشكاوي المتعلقة بالمخالفات المرتكبة من قبل الشركات العقارية.",
	},
	board_members: {
		en: "This service allows the owner to apply for committee member.",
		ar: "تتيح هذه الخدمة للمالك بتقديم طلب العضوية في لجنة الملاك.",
	},
	faqs: {
		en: "Frequently asked questions related to various services in Dubai REST",
		ar: "الأسئلة الاكثر تكراراً حول الخدمات المختلفة في دبي ريست",
	},
	dashboard: {
		en: "Gain a complete overview of your property/ies and perform transactions by selecting your property",
		ar: "تجد نظرة شاملة على عقاراتك و اتخاذ الاجراءات عليها"
	},
	profile: {
		en: "You can view and edit your personal information",
		ar: "يمكنك من عرض و تعديل بيانات الشخصية"
	},
	my_certificate_request: {
		en: "Track all your Ejari Requests which you have sent to the landlord/owner for approval",
		ar: "متابعة طلبات ايجاري التي ارسلتها للمالك للموافقة"
	},
	certificate_request_from_tenant: {
		en: "Track all your Ejari requests which are sent by the tenant for approval",
		ar: "تتبع كل طلبات ايجاري التي ارسلت من المستأجر للموافقة عليها"
	},
	enoc_mollak: {
		en: "Track your electronic no objection certificate request to owner association company.",
		ar: "تتبع طلب شهادة عدم ممانعة الإلكترونية إلى جمعية اتحاد الملاك.",
	},
	ptwimc: {
		en: "Requests for whomsoever it may concern for a property certificate. Go to My Request to view past requests.",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان تفصيلية لعقار أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
	},
	bcs_reclassification: {
		en: "This service allows customers to obtain a project report, know the condition of the land, and classify buildings according to the stars system.",
		ar: "تتيح هذه الخدمة للمتعاملين بالحصول على تقرير مشروع ومعرفة حالة الأرض وتصنيف المباني بنظام النجوم.",
	},
	handover_takeover: {
		en: "This workspace allows you to track all the request that has been raised by you. You can take actions like view, approve or reject request.",
		ar: "تتيح لك مساحة العمل هذه تتبع كل الطلبات التي قدمتها. يمكنك اتخاذ إجراءات مثل عرض الطلب أو الموافقة عليه أو رفضه.",
	},
	ht_my_requests: {
		en: "This workspace allows you to track all the request that has been raised by you. You can take actions like view, approve or reject request.",
		ar: "تتيح لك مساحة العمل هذه تتبع كل الطلبات التي قدمتها. يمكنك اتخاذ إجراءات مثل عرض الطلب أو الموافقة عليه أو رفضه.",
	},
	ht_requests_from_owner: {
		en: "This workspace allows you to track all the request raised from the owner. You can take actions like view, approve or reject request.",
		ar: "تتيح لك مساحة العمل هذه تتبع كل الطلبات المرفوعة من المالك. يمكنك اتخاذ إجراءات مثل عرض الطلب أو الموافقة عليه أو رفضه.",
	},
	mgm_contracts: {
		en: "View Management contract requests.",
		ar: "عرض طلبات عقود الإدارة.",
	},
	jop_services: {
		en: "A service that allows owners of the real estate units and tenants in the jointly owned properties to submit (suggestion, enquires or requests and complaints). It also allows owners committee to submit requests and issues rectification notice to hthe management company and following up on the owners submitted requests.",
		ar: " خدمة تتيح للملاك الوحدات العقارية والمستأجرين في العقارات المشتركة لتقديم  ( الاقتراحات ، الاستفسارات أو طلبات  والشكاوى ) كما تتيح للجنة الملاك  تقديم الطلبات وإصدار إنذارات تعديل الوضع لجهة الإدارة مع متابعة طلبات الملاك المقدمة."
	},
};
